import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Typography from 'WeployDesignLanguage/Typography';
import Button from 'WeployDesignLanguage/buttons/Button';
import Checkbox from 'LegacyWeployDesignLanguage/inputs/Checkbox';
import Grid from 'LegacyWeployDesignLanguage/Grid';
import Tooltip from 'WeployDesignLanguage/Tooltip';

import InfiniteScroll from '../../../containers/weployer/InfiniteScroll';
import TimesheetRow from './TimesheetRow';

const StyledRow = styled(Grid)`
  padding: ${props => props.theme.spacing[2]};
`;

const StyledMobileRow = styled(Grid)`
  padding: 0 ${props => props.theme.spacing[2]};
`;

const StyledCheckbox = styled(Checkbox)`
  margin-bottom: ${props => props.theme.spacing[2]};
`;

const StyledButton = styled(Button)`
  margin: 0 0 ${props => props.theme.spacing[2]} ${props => props.theme.spacing[1]};
`;

const StyledSelectedCount = styled.div`
  ${props => props.theme.typography.subtitle1}
  color: ${props => props.theme.colors.text.primary};
  padding-right: ${props => props.theme.spacing[2]};
`;

const StyledMobileSelectedCount = styled(StyledSelectedCount)`
  padding-top: ${props => props.theme.spacing[1]};
`;

const StyledTooltipWrapper = styled.div`
  margin-right: ${props => props.theme.spacing[2]};
  > div > label {
    margin-right: 0px;
  }
`;

const SubmittedTimesheets = ({
  timesheets,
  totalTimesheetsCount,
  onTimesheetRowClick,
  onTimesheetSelectChange,
  getChecked,
  mobileUser,
  mobileSelectMode,
  onBottomReached,
  isEndReached,
  scrollHeight,
  onTimesheetSelectAll,
  areAllTimesheetsSelected,
  onMobileSelectModeToggle,
  selectedTimesheetsCount,
  onApproveButtonClick,
}) => {
  const renderMobileTools = () => (
    <StyledMobileRow container justify="space-between">
      <Grid item>
        <Grid container>
          <Grid item>
            <Grid container>
              <StyledCheckbox
                onChange={onTimesheetSelectAll}
                checked={areAllTimesheetsSelected}
              />
            </Grid>
          </Grid>
          <StyledButton
            onClick={onMobileSelectModeToggle}
            appearance="text"
          >
            {mobileSelectMode ? 'Cancel' : 'Select'}
          </StyledButton>
        </Grid>
      </Grid>
      <Grid item>
        {
          mobileSelectMode &&
            <>
              <Grid container>
                {
                  selectedTimesheetsCount > 0 &&
                  <Grid item>
                    <StyledMobileSelectedCount>
                      {selectedTimesheetsCount}
                    </StyledMobileSelectedCount>
                  </Grid>
                }
                <Grid item>
                  <StyledButton
                    onClick={onApproveButtonClick}
                    disabled={selectedTimesheetsCount === 0}
                  >
                    Approve
                  </StyledButton>
                </Grid>
              </Grid>
            </>
        }
      </Grid>
    </StyledMobileRow>
  );

  const renderTools = () => (
    <StyledRow container justify="space-between">
      <Grid item>
        <Grid container>
          <StyledTooltipWrapper>
            <Tooltip text="Select All">
              <StyledCheckbox
                onChange={onTimesheetSelectAll}
                checked={areAllTimesheetsSelected}
              />
            </Tooltip>
          </StyledTooltipWrapper>
          <StyledButton
            onClick={onApproveButtonClick}
            disabled={selectedTimesheetsCount === 0}
          >
            Approve
          </StyledButton>
        </Grid>
      </Grid>
      <Grid item>
        <Grid container alignItems="center">
          {
            selectedTimesheetsCount > 0 &&
            <Grid item>
              <StyledSelectedCount>
                {selectedTimesheetsCount} selected
              </StyledSelectedCount>
            </Grid>
          }
          {
            !mobileUser &&
            <Typography>Showing { timesheets.length } of { totalTimesheetsCount }</Typography>
          }
        </Grid>
      </Grid>
    </StyledRow>
  );

  return (
    <>
      { mobileUser ? renderMobileTools() : renderTools() }
      <InfiniteScroll
        onBottomReached={onBottomReached}
        isEndReached={isEndReached}
        height={scrollHeight}
      >
        {
          timesheets.map(({ id, ...rest }) => (
            <TimesheetRow
              isChecked={getChecked(id)}
              key={id}
              {...rest}
              onClick={() => onTimesheetRowClick(id)}
              onCheckChange={() => onTimesheetSelectChange(id)}
              mobileSelectMode={mobileSelectMode}
            />
          ))
        }
      </InfiniteScroll>
    </>
  );
};

SubmittedTimesheets.propTypes = {
  timesheets: PropTypes.array.isRequired,
  totalTimesheetsCount: PropTypes.number.isRequired,
  onTimesheetRowClick: PropTypes.func.isRequired,
  onTimesheetSelectChange: PropTypes.func.isRequired,
  getChecked: PropTypes.func.isRequired,
  mobileUser: PropTypes.bool.isRequired,
  mobileSelectMode: PropTypes.bool.isRequired,
  onBottomReached: PropTypes.func.isRequired,
  isEndReached: PropTypes.bool.isRequired,
  scrollHeight: PropTypes.number.isRequired,
  onTimesheetSelectAll: PropTypes.func.isRequired,
  areAllTimesheetsSelected: PropTypes.bool.isRequired,
  onMobileSelectModeToggle: PropTypes.func.isRequired,
  selectedTimesheetsCount: PropTypes.number.isRequired,
  onApproveButtonClick: PropTypes.func.isRequired,
};

export default SubmittedTimesheets;
